import { render } from "./codePrefixDetail.vue?vue&type=template&id=27abdf1e"
import script from "./codePrefixDetail.vue?vue&type=script&lang=js"
export * from "./codePrefixDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vue\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__